import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

import { NoteExistsStatus } from "./note-exists-status";

@Injectable()
export class NotesService {

    private noteRequestedSource = new Subject<string>();
    public noteRequested$ = this.noteRequestedSource.asObservable();

    private noteExistsSource = new Subject<NoteExistsStatus>();
    public noteExists$ = this.noteExistsSource.asObservable();

	private closeNoteEvent = new Subject<void>();


	public sendCloseNoteEvent() {
	  this.closeNoteEvent.next();
	}


	public getCloseNoteEvent(): Observable<any>{
	  return this.closeNoteEvent.asObservable();
	}


    // Called by the submission history component when the note icon is clicked.
    // Should trigger the notes sidebar to appear for the given UUID.
    public openNote(uuid: string) {
        this.noteRequestedSource.next(uuid);
    }


    // Called by the notes component when a note has been created or deleted
    // Consumed by submission history component which should toggle the purple icon
    // for the given UUID.
    public setNoteExists(uuid: string, exists: boolean) {
        this.noteExistsSource.next(new NoteExistsStatus(uuid, exists));
    }
}
